import { AxiosError } from 'axios'

/**
 * Extracts the correlation ID from an error.
 *
 * The correlation ID is returned in the `x-correlation-id` response header
 * by the API routes when handling requests to the salesforce-gateway.
 *
 * Supported error shapes:
 * - AxiosError: read from `error.response.headers['x-correlation-id']`
 * - Plain rejection objects (from raw-fetch services) carrying a `correlationId` field
 */
export const getCorrelationIdFromError = (error: unknown): string | undefined => {
  if (isAxiosError(error)) {
    return error.response?.headers?.['x-correlation-id'] as string | undefined
  }

  if (hasCorrelationId(error)) {
    return error.correlationId
  }

  return undefined
}

const isAxiosError = (error: unknown): error is AxiosError => {
  return (error as AxiosError)?.isAxiosError === true
}

const hasCorrelationId = (error: unknown): error is { correlationId: string } => {
  return typeof (error as { correlationId?: unknown })?.correlationId === 'string'
}
